module.exports = __webpack_public_path__ + "img/31658152000100.1b51ea8c.png";